export const columnFields = [
	'id',
	'materialTemplateRef',
	'propertyTypes',

	'usageRefs',

	'createdAt',
	'updatedAt',
] as const;
